import React from 'react';
import {
  Checkbox, Col, Row, Select, Form,
} from 'antd';
import PropTypes from 'prop-types';
import './GridFields.scss';

const gridSizes = [
  { val: '0.5', name: '0.5 hectare' },
  { val: '1', name: '1 hectare' },
  { val: '1.5', name: '1.5 hectares' },
  { val: '2', name: '2 hectares' },
  { val: '2.5', name: '2.5 hectares' },
  { val: '3', name: '3 hectares' },
  { val: '5', name: '5 hectares' },
  { val: '10', name: '10 hectares' },
];

const proportions = [
  { name: '10%' },
  { name: '20%' },
  { name: '30%' },
  { name: '40%' },
  { name: '50%' },
  { name: '60%' },
  { name: '70%' },
  { name: '80%' },
  { name: '90%' },
  { name: '100%' },
];

const GridFields = (props): JSX.Element => {
  const { form, data } = props;

  const validateLayer20 = (): Promise<void> => {
    const layer020Rotina = form.getFieldValue('subtypeDynamicFields6');
    const layer020Micro = form.getFieldValue('subtypeDynamicFields8');
    const layer020Fisica = form.getFieldValue('subtypeDynamicFields10');

    if (layer020Rotina.length + layer020Micro.length + layer020Fisica.length === 0) {
      return Promise.reject(new Error('Pelo menos um dos campos de amostragem na camada 0-20cm deve estar selecionado'));
    }

    return Promise.resolve();
  };

  const renderGridFields = (): JSX.Element | null => {
    if (!data.serviceSubtype) {
      return null;
    }

    if (data.serviceSubtype.id === 1) {
      return (
        <div className="grid-text-information">
          <p style={{ fontSize: 16 }}>
            <b>Coleta: </b>
            Os procedimentos de coleta das amostras serão realizados pela Coopercitrus e
            será feita 1 (uma) coleta em cada talhão
          </p>
          <p style={{ fontSize: 16 }}>
            <b>Análise: </b>
            Os procedimentos de envio das amostras para análise no laboratório e também de
            obtenção dos relatórios com os resultados serão de responsabilidade do
            cooperado.
          </p>
        </div>
      );
    }

    if (data.serviceSubtype.id === 2) {
      return (
        <div className="grid-text-information">
          <p style={{ fontSize: 16 }}>
            <b>Coleta: </b>
            Os procedimentos de coleta das amostras serão realizados pela Coopercitrus e
            será feita 1 (uma) coleta em cada talhão.
          </p>
          <p style={{ fontSize: 16 }}>
            <b>Análise: </b>
            Os procedimentos de envio das amostras para análise no laboratório e também a
            entrega dos resultados para o cooperado com mapas de pontos georeferenciados e
            relatório das análises serão de responsabilidade da Coopercitrus.
          </p>
        </div>
      );
    }

    if (data.serviceSubtype.id === 3) {
      const dynamicField5 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 5);
      const dynamicField6 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 6);
      const dynamicField7 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 7);
      const dynamicField8 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 8);
      const dynamicField9 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 9);
      const dynamicField10 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 10);
      const dynamicField11 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 11);
      const dynamicField12 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 12);
      const dynamicField13 = data.serviceSubtypeDynamicFields.find((v) => v.dynamicFieldId === 13);

      return (
        <div>
          <Row gutter={24} className="inline-field">
            <Col span={24}>
              <Form.Item
                label={<span className="field-title-text">Tamanho do grid</span>}
                name="subtypeDynamicFields5"
                rules={[
                  { required: true, message: 'Por favor, selecione o tamanho do grid' },
                ]}
                initialValue={dynamicField5 ? dynamicField5.value : ''}
              >
                <Select style={{ minWidth: 80, width: '100%' }}>
                  {
                    gridSizes.map((v) => (
                      <Select.Option key={v.val} value={v.val}>
                        {v.name}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <div className="field-title-text" style={{ marginBottom: 8 }}>
                <span className="field-required-symbol">*</span>
                Amostragem na camada 0-20cm
              </div>
            </Col>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                label=""
                name="subtypeDynamicFields6"
                rules={[]}
                initialValue={(dynamicField6 && dynamicField6.value === 'true') ? ['rotina'] : []}
              >
                <Checkbox.Group
                  options={[{ label: 'Rotina, Alumínio e Enxofre:', value: 'rotina' }]}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ offset: 1, span: 23 }} className="proportion">
              <Form.Item
                shouldUpdate
              >
                {
                  (formInstanceParameter): JSX.Element | null => {
                    if (
                      formInstanceParameter
                        .getFieldValue('subtypeDynamicFields6')
                        .includes('rotina')
                    ) {
                      return (
                        <Form.Item
                          label={<span className="sampling">Proporção</span>}
                          name="subtypeDynamicFields7"
                          rules={[
                            { required: true, message: 'Por favor, selecione a proporção' },
                          ]}
                          initialValue={dynamicField7 ? dynamicField7.value : '100%'}
                        >
                          <Select style={{ minWidth: 80, width: '100%' }}>
                            {
                              proportions.map((v) => (
                                <Select.Option key={v.name} value={v.name}>
                                  {v.name}
                                </Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      );
                    }

                    return null;
                  }
                }
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                label=""
                name="subtypeDynamicFields8"
                rules={[]}
                initialValue={(dynamicField8 && dynamicField8.value === 'true') ? ['micro'] : []}
              >
                <Checkbox.Group options={[{ label: 'Micro', value: 'micro' }]} />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ offset: 1, span: 23 }} className="proportion">
              <Form.Item
                shouldUpdate
              >
                {
                  (formInstanceParameter): JSX.Element | null => {
                    if (
                      formInstanceParameter
                        .getFieldValue('subtypeDynamicFields8')
                        .includes('micro')
                    ) {
                      return (
                        <Form.Item
                          label={<span className="sampling">Proporção</span>}
                          name="subtypeDynamicFields9"
                          rules={[
                            { required: true, message: 'Por favor, selecione a proporção' },
                          ]}
                          initialValue={dynamicField9 ? dynamicField9.value : '100%'}
                        >
                          <Select style={{ minWidth: 80, width: '100%' }}>
                            {
                              proportions.map((v) => (
                                <Select.Option key={v.name} value={v.name}>
                                  {v.name}
                                </Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      );
                    }

                    return null;
                  }
                }
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                label=""
                name="subtypeDynamicFields10"
                rules={
                  [
                    { validator: validateLayer20 },
                  ]
                }
                initialValue={(dynamicField10 && dynamicField10.value === 'true') ? ['fisica'] : []}
              >
                <Checkbox.Group options={[{ label: 'Física', value: 'fisica' }]} />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ offset: 1, span: 23 }} className="proportion">
              <Form.Item
                shouldUpdate
              >
                {
                  (formInstanceParameter): JSX.Element | null => {
                    if (
                      formInstanceParameter
                        .getFieldValue('subtypeDynamicFields10')
                        .includes('fisica')
                    ) {
                      return (
                        <Form.Item
                          label={<span className="sampling">Proporção</span>}
                          name="subtypeDynamicFields11"
                          rules={[
                            { required: true, message: 'Por favor, selecione a proporção' },
                          ]}
                          initialValue={dynamicField11 ? dynamicField11.value : '100%'}
                        >
                          <Select style={{ minWidth: 80, width: '100%' }}>
                            {
                              proportions.map((v) => (
                                <Select.Option key={v.name} value={v.name}>
                                  {v.name}
                                </Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      );
                    }

                    return null;
                  }
                }
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <div className="field-title-text" style={{ marginBottom: 8 }}>
              Amostragem na camada 20-40cm
            </div>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                label=""
                name="subtypeDynamicFields12"
                rules={[]}
                initialValue={
                  (dynamicField12
                    && dynamicField12.value === 'true')
                    ? ['rotina']
                    : []
                }
              >
                <Checkbox.Group
                  options={
                    [
                      {
                        label: 'Rotina, Alumínio e Enxofre:',
                        value: 'rotina',
                      },
                    ]
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ offset: 1, span: 23 }} className="proportion">
              <Form.Item
                shouldUpdate
              >
                {
                  (formInstanceParameter): JSX.Element | null => {
                    if (
                      formInstanceParameter
                        .getFieldValue('subtypeDynamicFields12')
                        .includes('rotina')
                    ) {
                      return (
                        <Form.Item
                          label={<span className="sampling">Proporção</span>}
                          name="subtypeDynamicFields13"
                          rules={[
                            { required: true, message: 'Por favor, selecione a proporção' },
                          ]}
                          initialValue={dynamicField13 ? dynamicField13.value : '100%'}
                        >
                          <Select style={{ minWidth: 80, width: '100%' }}>
                            {
                              proportions.map((v) => (
                                <Select.Option key={v.name} value={v.name}>
                                  {v.name}
                                </Select.Option>
                              ))
                            }
                          </Select>
                        </Form.Item>
                      );
                    }

                    return null;
                  }
                }
              </Form.Item>
            </Col>
          </Row>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="GridFields">
      {renderGridFields()}
    </div>
  );
};

GridFields.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

GridFields.defaultProps = {};

export default GridFields;
